import { inject } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { ActivityRecommendations } from '@shared-ui/local-expert-activities';
import { useBexApi } from '@shared-ui/bex-api-context';

import { DateUtils } from 'utils/date-utils';

import { Lazy } from 'components/common/lazy/lazy';

export const ActivityRecommendationsWrapper = inject('currentHotel')(({ currentHotel }) => {
  const { context } = useBexApi();

  const searchData = currentHotel && currentHotel.offerSearchData;

  return (
    <ErrorBoundary label="hotel.information.activities">
      <>
        {context && currentHotel && currentHotel.hotelId && searchData && searchData.startDate && searchData.endDate && (
          <Lazy>
            <Lazy.Placeholder>
              <div data-stid="recommended-activities__placeholder" />
            </Lazy.Placeholder>
            <Lazy.Loaded>
              <AbacusExperiment name="LX_ACTIVITIES_NEARBY_HOTEL">
                <AbacusControl />
                <AbacusVariant bucket={1}>
                  <ActivityRecommendations
                    inputs={{
                      context,
                      destination: {
                        regionId: String(currentHotel.hotelId),
                        regionType: 'hotel'
                      },
                      dateRange: {
                        startDate: DateUtils.parseDateString(searchData.startDate),
                        endDate: DateUtils.parseDateString(searchData.endDate)
                      }
                    }}
                    skipSsr={true}
                  />
                </AbacusVariant>
              </AbacusExperiment>
            </Lazy.Loaded>
          </Lazy>
        )}
      </>
    </ErrorBoundary>
  );
});
